import React, { useState } from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { WifiQuality } from "api/onboardingTypes";
import { useGreenEnergyContext } from "contexts/GreenEnergyContext";
import { useSetError, useErrorInfo } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

const FRAME_DATA = {
  title: "Buscar melhores soluções",
  h2Subtitle: "Indique a qualidade do wi-fi nos ambientes climatizados",
  explanationBody:
    "Nossas soluções precisam de Wi-Fi para evitar desperdício de energia",
  buttonText: "Continuar",
  nextScreen: "electrical-capacity",
  skipTo: "electrical-capacity",
  imgSrc: "/static/img/solutions/wifi.png",
};

const WIFI_DATA: Array<{ value: WifiQuality; text: string }> = [
  {
    value: "great",
    text: "Boa em todos os ambientes ",
  },
  {
    value: "reasonable",
    text: "Boa na maioria dos ambientes",
  },
  {
    value: "bad",
    text: "Ruim na maioria dos ambientes",
  },
];

export const RoomWifiStatus = ({ history }) => {
  const [status, setStatus] = useState<WifiQuality>();
  const { setWifiStatus } = useGreenEnergyContext();
  const setGlobalError = useSetError();
  const errorInfo = useErrorInfo();
  const hasFormError = errorInfo?.code === CustomCodes.INCOMPLETE_FORM;

  const handleSubmit = () => {
    if (status) {
      setWifiStatus(status);
      history.push(FRAME_DATA.nextScreen);
    } else {
      setGlobalError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  return (
    <SolutionsFrame {...FRAME_DATA} onButtonClick={handleSubmit}>
      <BlockStandard hideDivider>
        <List>
          {WIFI_DATA.map(({ value, text }) => (
            <ListItem
              disablePadding
              key={value}
              sx={{
                border: `1px solid ${hasFormError && !status ? "red" : "#595959"}`,
                borderRadius: "12px",
                mb: 2,
              }}
            >
              <ListItemButton onClick={() => setStatus(value)}>
                <ListItemIcon>
                  <Checkbox
                    sx={{ color: "#595959" }}
                    color="success"
                    edge="start"
                    checked={status === value}
                  />
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </BlockStandard>
    </SolutionsFrame>
  );
};
